module.exports = __webpack_public_path__ + "static/media/leinster.b6c6c07d.png";